const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  // name: (state) => state.user.name,
  name: () => "Админ",
  firstName: (state) => state.user.firstName,
  lastName: (state) => state.user.lastName,
  // mediaUrl: (state) => state.user.mediaUrl,
  mediaUrl: () => process.env.VUE_APP_MEDIA,
  siteUrl: () => process.env.VUE_APP_SITE_URL,
  role: (state) => state.user.role,
  roles: () => ["admin"],
  types: (state) => {
    return {
      regional: state.settings.regional_id,
      federal: state.settings.federal_id,
    };
  },
  permission_routes: (state) => state.permission.routes,
  locations: (state) => state.locations.locations,
  pollingToken: (state) => state.polling.token,
};
export default getters;
